module.exports = __webpack_public_path__ + "img/dtddyq.691bafbd.svg";